<div class="custom-row">
  <div class="col-md-12 text-left">
    <div [innerHTML]="htmlText"></div>
  </div>
</div>

<body>
  <div id="signature-pad" class="signature-pad">
    <div class="signature-pad--body">
      <canvas #sPad></canvas>
    </div>
    <div class="signature-pad--footer">
      <div class="description">Sign above</div>
    </div>
  </div>

</body>
<div class="indent">
  <input #agreeChk type="checkbox" (change)="validatePad($event)"/>
  By checking this box, you are acknowledging that you have read and agree to the terms above.
</div>
<br>

<div class="custom-row">
  <div class="col text-right">
    <button type="button" class="btn product-btn gray-btn button-margin" (click)="clearPad(agreeChk)">Clear</button>
    <button type="button" class="btn product-btn gray-btn button-margin" [disabled]="disableSave" (click)="saveSignature()">Save</button>
  </div>
</div>